/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkuNzUgMi41VjFIOS4wNjI1VjIuNUg0LjkzNzVWMUg0LjI1VjIuNUgxLjVWMTNIMTIuNVYyLjVIOS43NVpNMTEuODEyNSAxMi4yNUgyLjE4NzVWNS41SDExLjgxMjVWMTIuMjVaTTIuMTg3NSA0Ljc1VjMuMjVIMTEuODEyNVY0Ljc1SDIuMTg3NVoiIGZpbGw9ImJsYWNrIi8+PC9zdmc+";